<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-autocomplete
              :items="power_plants"
              item-text="name"
              prepend-icon="flash_on"
              label="Planta"
              v-model="power_plant"
              return-object
              clearable
              :rules="powerPlantRules"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md2>
            <v-text-field
              v-model="competence"
              :rules="competenceRules"
              label="Competencia"
              prepend-icon="event"
              class="purple-input"
              :value="current_date"
              @keyup.enter="validate"
              mask="##/####"
            />
          </v-flex>

          <v-flex xs12 md4>
            <v-select
              v-model="status"
              :items="statusList"
              label="Status"
              multiple
              chips
              hint="(opcional)"
              persistent-hint
              item-text="text"
              item-value="value"
            >
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="toggle">
                  <v-list-tile-action>
                    <v-icon
                      :color="status.length > 0 ? 'indigo darken-4' : ''"
                      >{{ icon }}</v-icon
                    >
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecionar todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-flex xs6 md6 class="text-lg-right">
              <v-btn
                color="primary"
                @click="validate()"
                :disabled="!valid || loading"
                :loading="loading"
                small
                outline
                slot="start"
              >
                <v-icon>search</v-icon>Buscar
              </v-btn>
            </v-flex>
            <v-spacer />
            <!-- <v-flex
              xs6
              md6
              v-if="(isAdmin || isFinancial)"
            >
              <v-btn
                color="success"
                @click="invoiceForm()"
                :disabled="loading"
                small outline slot="end"
              >
                  <v-icon class="pr-1">receipt_long</v-icon>Adicionar
              </v-btn>
            </v-flex> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { EventBus } from "../../utils/event-bus";
import { statusList } from "../../utils/billing_status.json";

export default {
  // props: ['powerplants'],
  data: () => ({
    // competence: '',
    // power_plant: '',
    power_plants: [],
    valid: false,
    // loading: false,
    invoices: [],
    statusList: statusList,
    current_date: new Date(),
    powerPlantRules: [
      (v) => !!v || "Por favor, selecione a planta que deseja ver as faturas.",
    ],
    competenceRules: [
      (v) => !!v || "Por favor, preencher a competência da fatura.",
      (v) =>
        !(v.substr(2, 4) < 2019) ||
        "Por favor, o ano deve ser valido. " + v.substr(2, 4),
      (v) =>
        !(v.substr(0, 2) > 12) ||
        "Por favor, o mes deve ser valido. " + v.substr(0, 2),
    ],
  }),
  async created() {
    // console.log('created power_plants: ', this.power_plants)
    if (!this.powerplants || this.power_plants.length <= 0) {
      const pp = await this.getPowerPlants();
      // console.log('pp: ', pp)
      this.power_plants = this.filterPowerPlants(pp);
    }
    if (this.filters && this.filters.power_plant) {
      this.power_plant = this.filters.power_plant;
    }
    if (this.filters && this.filters.competence) {
      this.competence = this.filters.competence;
    }
  },
  computed: {
    ...mapState(["powerplants", "user"]),
    ...mapState("uniquebilling", ["billingFilters", "loading"]),
    status: {
      get() {
        // console.log('status: ', this.$store.state.billing.billingFilters.status)
        return this.$store.state.uniquebilling.billingFilters.status;
      },
      set(value) {
        this.$store.commit("uniquebilling/setBillingFilterStatus", value);
      },
    },

    power_plant: {
      get() {
        // console.log('power_plant: ', this.$store.state.billing.billingFilters.power_plant_id)
        return this.$store.state.uniquebilling.billingFilters.power_plant_id;
      },
      set(value) {
        // console.log('power_plant value:', value)
        this.$store.commit("uniquebilling/setBillingFilterPowerPlant", value);
      },
    },
    competence: {
      get() {
        // console.log('competence: ', this.billingFilters.competence)
        return this.billingFilters.competence;
      },
      set(value) {
        // console.log('competence value:', value)
        this.$store.commit("uniquebilling/setBillingFilterCompetence", value);
      },
    },
    likesAllStatus() {
      return this.status.length === this.statusList.length;
    },
    likesSomeStatus() {
      return this.status.length > 0 && !this.likesAllStatus;
    },
    icon() {
      if (this.likesAllStatus) return "mdi-close-box";
      if (this.likesSomeStatus) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("admin") >= 0) {
        return true;
      }
      return false;
    },
    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("financial") >= 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    power_plants() {
      // console.log('watch power_plants: ', this.power_plants)
      if (!this.power_plants && this.powerplants) {
        this.power_plants = this.filterPowerPlants(this.powerplants);
      }
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllStatus) {
          this.status = [];
        } else {
          this.status = this.statusList.slice().map((item) => item.value);
        }
      });
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        // console.log('this.power_plant: ', this.power_plant.id)
        // console.log('this.competence: ', this.competence)
        // console.log('this.status: ', this.status)
        let params = {
          power_plant_id: this.power_plant.id,
          competence: this.competence,
          status: this.status,
        };
        console.log("params: ", params);
        // const billings =
        await this.getUniqueBillingByParams(params);
        // console.log('billingsz: ', billings)
        // const tot = this.getTotalBillings(params)
        // tot
        //   .then(() => {
        //     this.loading = false
        //   })
        //   .catch(err => {
        //     console.error(err.message)
        //     this.loading = false
        //   })
      }
    },
    filterPowerPlants(_powerplants) {
      var PowerPlantArray = [];
      if (_powerplants && this.user) {
        if (
          this.user.group &&
          (this.user.group.indexOf("admin") >= 0 ||
            this.user.group.indexOf("financial") >= 0)
        )
          return _powerplants;
        const user_pp = this.user.powerplants || this.user.power_plants;

        if (user_pp && user_pp.length > 0) {
          _powerplants.filter((power_plant) => {
            return user_pp.filter((power_plant2) => {
              if (power_plant2.power_plant_id === power_plant.id) {
                PowerPlantArray.push(power_plant);
              }
            });
          });
        }
      }
      return PowerPlantArray;
    },
    invoiceForm() {
      EventBus.$emit("showForm", true);
    },
    ...mapActions(["getPowerPlants"]),
    ...mapActions("uniquebilling", ["getUniqueBillingByParams"]),
  },
};
</script>
